import { authUrls } from '@/configs/endpoints'
import api from '@/plugins/api'
import { GOOGLE_REMINDER_KEY } from '@/configs/constants'
import { isAuth, clearSession } from '@/plugins/tokenStorage'

class Authorization {
  isAuth() {
    return isAuth()
  }

  async logout() {
    try {
      await api.get(authUrls.logout) // best-effort: invalidate the refresh cookie on the backend
    } catch (error) {
      console.error('Logout request failed:', error)
    }
    clearSession()
    localStorage.removeItem(GOOGLE_REMINDER_KEY)
    localStorage.removeItem('isAdmin')
    // clear legacy cookies from the previous token model
    document.cookie = 'TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    document.cookie = 'uid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
  }
}

const authorization = new Authorization()

export default authorization
